var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.715 16.651L16 10.456l6.285 6.196a1.016 1.016 0 001.428 0 .994.994 0 000-1.414l-6.999-6.899c-.379-.375-1.048-.377-1.429 0l-6.999 6.9a.994.994 0 000 1.414 1.019 1.019 0 001.429-.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.714 15.338c-.379-.375-1.048-.377-1.429 0l-6.999 6.899a.994.994 0 000 1.414 1.016 1.016 0 001.428 0L16 17.456l6.285 6.196a1.016 1.016 0 001.428 0 .994.994 0 000-1.414l-6.999-6.9z"
  })));
}

export default SvgDoubleUp;